export const destructiveActionFormatStrings = {
  cancelLabel: {
    en: "No, keep it",
    es: "No, manténlo",
    fr: "Non, garde-le",
  },
  confirmLabel: {
    en: "Yes, delete it",
    es: "Sí, elimínalo",
    fr: "Oui, supprime-le",
  },
};
